import React from "react";

// Temporary comparison page for choosing the hero background image (bright treatment).
const options = [
  {
    n: 1,
    label: "White sculptural bridge + waterfront skyline (current)",
    note: "Business district connected by a bridge \u2014 closest to your reference",
    image:
      "https://images.pexels.com/photos/30586755/pexels-photo-30586755.jpeg?auto=compress&cs=tinysrgb&w=1400",
  },
  {
    n: 2,
    label: "Modern waterfront financial district",
    note: "Bright daylight, dense skyline",
    image:
      "https://images.unsplash.com/photo-1641387573142-5e836cf9c4b4?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  },
  {
    n: 3,
    label: "Skyline with golden light on water",
    note: "Warm, optimistic, premium",
    image:
      "https://images.unsplash.com/photo-1784051298653-20cc29b0cd50?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  },
  {
    n: 4,
    label: "Cable-stayed bridge + skyline (blue sky)",
    note: "Crisp, engineered, confident",
    image:
      "https://images.pexels.com/photos/31343457/pexels-photo-31343457.jpeg?auto=compress&cs=tinysrgb&w=1400",
  },
  {
    n: 5,
    label: "Cable-stayed bridge linking a city",
    note: "Strong connection metaphor at dusk",
    image:
      "https://images.pexels.com/photos/20367010/pexels-photo-20367010.jpeg?auto=compress&cs=tinysrgb&w=1400",
  },
];

const HeroOptions = () => {
  return (
    <div className="bg-[#F6F7F9] pb-20 pt-28">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <h1 className="text-3xl font-semibold text-[#0F2A4A]">
          Hero image options
        </h1>
        <p className="mt-2 text-slate-600">
          Business-district-and-bridge images, shown in the new bright hero
          treatment. Reply with the number you prefer.
        </p>

        <div className="mt-10 grid grid-cols-1 gap-8 lg:grid-cols-2">
          {options.map((o) => (
            <div key={o.n} className="overflow-hidden rounded-2xl shadow-lg">
              <div className="relative h-72 overflow-hidden bg-white">
                <div className="absolute inset-y-0 right-0 w-[66%]">
                  <img
                    src={o.image}
                    alt={o.label}
                    className="h-full w-full object-cover"
                  />
                  <div className="absolute inset-0 bg-gradient-to-r from-white via-white/80 to-white/10" />
                </div>
                <div className="absolute left-6 top-5 flex h-9 w-9 items-center justify-center rounded-full bg-[#B8862F] text-sm font-bold text-white">
                  {o.n}
                </div>
                <div className="relative flex h-full flex-col justify-center px-8">
                  <h2 className="text-3xl font-extrabold uppercase leading-none tracking-tight text-[#16233B]">
                    20 Years.
                    <br />
                    Across Borders.
                  </h2>
                  <div className="mt-3 h-1 w-16 bg-[#B8862F]" />
                  <p className="mt-3 text-[11px] font-semibold uppercase tracking-[0.24em] text-slate-500">
                    Connecting Business. Creating Opportunity.
                  </p>
                </div>
              </div>
              <div className="bg-white px-6 py-4">
                <div className="font-semibold text-[#0F2A4A]">
                  Option {o.n}: {o.label}
                </div>
                <div className="text-sm text-slate-500">{o.note}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default HeroOptions;
